(function ($) {
  const videoTextSections = document.querySelectorAll('.video-text-section');
  
  if (videoTextSections.length === 0) {
    return;
  }

  // Load YouTube API
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';

  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  
  const players = new Map();

  window.onYouTubeIframeAPIReady = function () {
    $('.video-text-section iframe').each(function () {
      const iframe = this;
      const iframeId = iframe.id;

      if (!iframeId) {
        console.error('YouTube iframe is missing an ID');
        return;
      }

      const player = new YT.Player(iframeId, {
        events: {
          onStateChange(event) {
            const $section = $(iframe).closest('.video-text-section');

            if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
              $section.find('.video-play-button').show();
              $section.find('img').show();
            }
          }
        }
      });

      players.set(iframeId, player);
    });
  };

  $(document).ready(function () {
    $('.video-play-button').on('click', function () {
      const $section = $(this).closest('.video-text-section');
      const iframe = $section.find('iframe')[0];
      
      if (!iframe) {
        console.error('No iframe found in section');
        return;
      }

      const iframeId = iframe.id;
      $(this).hide();
      $section.find('img').hide();

      const player = players.get(iframeId);

      if (player && typeof player.playVideo === 'function') {
        player.playVideo();
      }
    });
  });
})(jQuery);